import { Contrast } from 'lucide-react';

import { useTheme } from '../theme/use-theme';

import { Button } from './button';

export function ThemeToggle({ className }: { className?: string } = {}) {
  const { resolved, setPreference } = useTheme();
  const next = resolved === 'dark' ? 'light' : 'dark';
  return (
    <Button
      variant="ghost"
      size="icon"
      {...(className ? { className } : {})}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
      onClick={() => setPreference(next)}
    >
      <Contrast className="size-4" aria-hidden="true" />
    </Button>
  );
}
